import { defineMessages } from 'react-intl'

export default defineMessages({
  loading: {
    id: 'components.MemoryDetails.loading',
    defaultMessage: 'Loading…',
  },
  linksHeading: {
    id: 'components.MemoryDetails.linksHeading',
    defaultMessage: 'Links',
  },
  customerLabel: {
    id: 'components.MemoryDetails.customerLabel',
    defaultMessage: 'Customer',
  },
  customerPlaceholder: {
    id: 'components.MemoryDetails.customerPlaceholder',
    defaultMessage: 'Search by name or order ID…',
  },
  orderLabel: {
    id: 'components.MemoryDetails.orderLabel',
    defaultMessage: 'Order',
  },
  orderPlaceholder: {
    id: 'components.MemoryDetails.orderPlaceholder',
    defaultMessage: 'Search by name…',
  },
  taskLabel: {
    id: 'components.MemoryDetails.taskLabel',
    defaultMessage: 'Task ID',
  },
  taskPlaceholder: {
    id: 'components.MemoryDetails.taskPlaceholder',
    defaultMessage: 'Search by task UID…',
  },
  textValueHeading: {
    id: 'components.MemoryDetails.textValueHeading',
    defaultMessage: 'Text / Value',
  },
  memoryIndex: {
    id: 'components.MemoryDetails.memoryIndex',
    defaultMessage: 'Memory {index}',
  },
  memoryTextLabel: {
    id: 'components.MemoryDetails.memoryTextLabel',
    defaultMessage: 'Memory text',
  },
  memoryTextPlaceholder: {
    id: 'components.MemoryDetails.memoryTextPlaceholder',
    defaultMessage: 'Enter the word or phrase…',
  },
  languageHeading: {
    id: 'components.MemoryDetails.languageHeading',
    defaultMessage: 'Language',
  },
  languageLabel: {
    id: 'components.MemoryDetails.languageLabel',
    defaultMessage: 'Language',
  },
  languagePlaceholder: {
    id: 'components.MemoryDetails.languagePlaceholder',
    defaultMessage: 'Search by language name…',
  },
  removeButton: {
    id: 'components.MemoryDetails.removeButton',
    defaultMessage: 'Remove',
  },
  addAnotherMemory: {
    id: 'components.MemoryDetails.addAnotherMemory',
    defaultMessage: '+ Add another memory',
  },
  savingButton: {
    id: 'components.MemoryDetails.savingButton',
    defaultMessage: 'Saving…',
  },
  saveChanges: {
    id: 'components.MemoryDetails.saveChanges',
    defaultMessage: 'Save changes',
  },
  createMemories: {
    id: 'components.MemoryDetails.createMemories',
    defaultMessage: 'Create {count} memories',
  },
  createMemory: {
    id: 'components.MemoryDetails.createMemory',
    defaultMessage: 'Create memory',
  },
  cancel: {
    id: 'components.MemoryDetails.cancel',
    defaultMessage: 'Cancel',
  },
  loadError: {
    id: 'components.MemoryDetails.loadError',
    defaultMessage: 'Failed to load memory',
  },
})
